import React from "react";
import { Link } from "react-router-dom";

const LABEL = { tanya: "Today's Tanya", hayomyom: "Today's Hayom Yom", parsha: "This Week's Parsha" };

export default function RagRecurring({ recurring }) {
  if (!recurring || recurring.error) {
    return (
      <div className="rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-4 text-primaryDark">
        Daily study is not available right now.
      </div>
    );
  }

  const type = recurring.recurring_type || recurring.type;

  return (
    <div className="rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-4">
      <div className="font-extrabold text-primaryDark text-lg">{LABEL[type] || "Daily Study"}</div>
      {(recurring.hebrew_date || recurring.civil_date) && (
        <div className="text-sm text-primaryDark opacity-70 mb-2">
          {recurring.hebrew_date} {recurring.civil_date ? `· ${recurring.civil_date}` : ""}
        </div>
      )}

      {type === "parsha" ? (
        <div className="text-primaryDark">
          <div className="mb-1">{recurring.parsha_title}</div>
          {recurring.category && (
            <Link className="text-primaryBlue hover:underline" to={`/category/${recurring.category.slug}`}>
              {recurring.category.name}
            </Link>
          )}
        </div>
      ) : (
        <ul className="space-y-1">
          {(recurring.classes || []).map((c) => (
            <li key={c.class_id}>
              <Link
                className="text-primaryBlue hover:underline"
                to={`/${c.permalink ?? c.class_id}`}
              >
                {c.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
